import React, { useState, useEffect } from "react";
import { useStore } from "react-admin";
// mui
import { Card, CardContent, Typography, Grid, Skeleton } from "@mui/material";
import { dataProvider } from "../../../Provider/parseDataProvider";

export const RegistrationSummary = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [registrationSummaryCall, setRegistrationSummaryCall] = useStore(
    "registrationSummaryCall"
  );

  // Fetch user count data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await dataProvider.userCount();
        // Set the fetched data directly if it matches the required structure
        setData(response);
      } catch (error) {
        console.error("Error fetching user count:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [registrationSummaryCall]);

  useEffect(() => {
    if (loading === false && registrationSummaryCall) {
      setRegistrationSummaryCall(false); // Reset the flag after fetching data
    }
  }, [loading, registrationSummaryCall, setRegistrationSummaryCall]);

  return (
    <React.Fragment>
      <Grid item xs={12} sm={12} md={12} sx={{ mt: 1 }}>
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ fontSize: 22, fontWeight: 500, color: "#FFF" }}
            >
              Registration Summary
            </Typography>

            <Grid container spacing={2}>
              {loading ? (
                <>
                  {[...Array(3)].map((_, index) => (
                    <Grid item xs={12} sm={4} md={4} key={index}>
                      <Card
                        variant="outlined"
                        sx={{
                          mt: 1,
                          border: "1px solid #1A1A1A",
                          background: "#1A1A1A",
                        }}
                      >
                        <CardContent>
                          <Skeleton
                            width="60%"
                            height={20}
                            sx={{
                              mt: 1,
                              background: "#fff",
                            }}
                          />
                          <Skeleton
                            width="40%"
                            height={30}
                            sx={{
                              mt: 1,
                              background: "#fff",
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </>
              ) : (
                data?.map((item) => (
                  <Grid item xs={12} sm={4} md={4} key={item?.id}>
                    <Card
                      variant="outlined"
                      sx={{
                        mt: 1,
                        border: "1px solid #1A1A1A",
                        background: "#1A1A1A",
                      }}
                    >
                      <CardContent>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: "rgba(255, 255, 255, 0.70)",
                          }}
                        >
                          {item?.name}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: 24,
                            fontWeight: 400,
                            color: item?.color,
                            marginTop: 2,
                          }}
                        >
                          {item?.count}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </React.Fragment>
  );
};
